var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    rx: 12,
    fill: "url(#paint0_radial_3370_7785)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 63.0834C55.5541 63.0834 62.0833 56.5542 62.0833 48.5001C62.0833 40.4459 55.5541 33.9167 47.5 33.9167C39.4458 33.9167 32.9167 40.4459 32.9167 48.5001C32.9167 56.5542 39.4458 63.0834 47.5 63.0834Z",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2083 44.125C40.5138 44.9746 41.3382 45.5833 42.3072 45.5833C43.2762 45.5833 44.1005 44.9746 44.4061 44.125M50.594 44.125C50.8995 44.9746 51.7238 45.5833 52.6928 45.5833C53.6618 45.5833 54.4862 44.9746 54.7917 44.125",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 52.875C42.9968 54.646 45.1146 55.7917 47.5 55.7917C49.8854 55.7917 52.0032 54.646 53.3333 52.875",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3370_7785",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1733 65.9267) rotate(-90) scale(65.9267 99.4785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217494,
    stopColor: "#1E8157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510916,
    stopColor: "#1F6546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726911,
    stopColor: "#1F573E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204533"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.9640d7e8cb3fc097b8f9a5cc4f116e63.svg";
export { ForwardRef as ReactComponent };